import type { GetSuprSendUserBody } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { notificationsKeys } from "@/hooks/queryKeys";
import { useUser } from "@/hooks/useUser";
import apiClient from "@/lib/api/client";

export function useGetSuprSendUser() {
  const { data } = useUser();

  return useQuery({
    enabled: !!data?.user.email,
    queryFn: () =>
      apiClient
        .url(`/notifications/supr-send/user`)
        .get()
        .json<GetSuprSendUserBody>(),
    queryKey: notificationsKeys.user(data?.user.email ?? "unknown"),
  });
}
